import fileSaver from "file-saver";
export function createProviderClass(api) {
  return class extends HTMLElement {
    get $$typeof() {
      return "provider";
    }
    resolve() {
      return api(...arguments);
    }
    async saveAs(filename) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const blob = await api(...args);
      fileSaver.saveAs(blob, filename);
    }
  };
}
//# sourceMappingURL=createProviderClass.js.map